import React, { useState } from "react";

// Product List
const products = [
  {
    id: "P001",
    image: require("../assets/dRed.jpeg"), // Suggested: crispy red & white fried onions in a bowl
    name: "Dehydrated Fried Onions Red",
    category: "Dehydrated",
    description: "Crunchy, flavor-packed fried onions made from red onion varieties, ideal for garnishing and seasoning.",
    hexCode: "25585DF53",
  },

  {
    id: "P002",
    image: require("../assets/white.jpeg"), // Suggested: coated onion rings close-up
    name: "Dehydrated Fried Coated Onions White",
    category: "Dehydrated",
    description: "Deep-fried coated white onion slices with a crisp outer layer, perfect for snacks or toppings.",
    hexCode: "25585DF53",
  },
  {
    id: "P003",
    image: require("../assets/red_o_powder.png"), // Suggested: red onion powder in spoon or bowl
    name: "Red Onion Powder",
    category: "Dehydrated",
    description: "Finely ground powder made from dried red onions, rich in flavor and aroma for everyday cooking.",
    hexCode: "25585DF53",
  },
  {
    id: "P004",
    image: require("../assets/white_onion_powder.png"), // Suggested: white powder in spice jar
    name: "White Onion Powder",
    category: "Dehydrated",
    description: "Smooth, light-colored powder from dried white onions, great for soups, sauces, and seasoning.",
    hexCode: "25585DF53",
  },
  {
    id: "P006",
    image: require("../assets/flakes.jpeg"), // Suggested: colorful red and white onion flakes on a wooden plate
    name: "Red and White Onion Flakes",
    category: "Dehydrated",
    description: "Mixed flakes of red and white dehydrated onions, perfect for soups, pizzas, and savory dishes.",
    hexCode: "25585DF53",
  },
  {
    id: "P007",
    image: require("../assets/red.jpeg"), // Suggested: coated onion rings close-up
    name: "Dehydrated Fried Coated Onions Red",
    category: "Dehydrated",
    description: "Deep-fried coated white onion slices with a crisp outer layer, perfect for snacks or toppings.",
    hexCode: "25585DF53",
  },
  {
    id: "P008",
    image: require("../assets/dwhite.jpeg"), // Suggested: crispy red & white fried onions in a bowl
    name: "Dehydrated Fried Onions White",
    category: "Dehydrated",
    description: "Crunchy, flavor-packed fried onions made from  white onion varieties, ideal for garnishing and seasoning.",
    hexCode: "25585DF53",
  },
  {
    id: "P011",
    image: require("../assets/organic_turmeric_powder.png"),
    name: "Organic Turmeric Powder",
    category: "Turmeric Powder",
    description:
      "High-quality turmeric powder rich in curcumin, known for its anti-inflammatory and antioxidant properties.",
    hexCode: "25585DF54",
  },
  {
    id: "P012",
    image: require("../assets/organic_turmeric_powder.png"),
    name: "Premium Turmeric Spice Blend",
    category: "Turmeric Powder",
    description:
      "A curated blend featuring turmeric with complementary spices, perfect for golden milk, curries, and health tonics.",
    hexCode: "25585DF54",
  },
];

// Product Categories Tabs
function getRandomProducts(count) {
  const shuffled = [...products].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count).map((prod) => ({
    name: prod.name,
    desc: prod.description,
    image: prod.image,
  }));
}

// Product Categories Tabs
const data = {
  "New Arrival": getRandomProducts(3),
  "Trending Products": getRandomProducts(3),
  "BestSeller": getRandomProducts(3),
};

// Achievement Stats
const achievements = [
  { count: "10+", label: "Happy Client" },
  { count: "20+", label: "Product Sold" },
  { count: "11+", label: "Shipment Done" },
  { count: "11+", label: "Shipment Done" }, // Consider replacing duplicate label
];

// Component
export default function OurAchievements() {
  const [activeTab, setActiveTab] = useState("Trending Products");

  return (
    <section className="py-10 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Column - Product Tabs */}
          <div className="w-full md:w-1/2 bg-gradient-to-r from-[#9c6027] via-[#c48c5c] to-[#f1d3a2] p-4 rounded-2xl shadow-md flex flex-col justify-between">
            {/* Tabs */}
            <div className="flex justify-around border-b pb-2 mb-4 font-semibold text-black">
              {Object.keys(data).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-3 py-1 transition-all ${activeTab === tab
                      ? "text-blue-900 font-bold border-b-2 border-blue-900"
                      : "text-black"
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Product Cards */}
            <div className="flex flex-col gap-4 overflow-y-auto max-h-[400px]">
              {data[activeTab].map((prod, index) => (
                <div
                  key={index}
                  className="flex bg-white shadow rounded-lg overflow-hidden"
                >
                  <img
                    src={prod.image}
                    alt={prod.name}
                    className="w-24 h-24 object-cover"
                  />
                  <div className="p-4 flex-1">
                    <h4 className="text-lg font-semibold">{prod.name}</h4>
                    <p className="text-sm text-gray-600">{prod.desc}</p>
                    <div className="text-gray-300 text-sm mt-2">★★★★★</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Achievements */}
          <div className="w-full md:w-1/2 flex flex-col justify-between items-center bg-[#fff] rounded-2xl p-4 shadow-md">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mb-16 drop-shadow-sm">
              Our Achievements
            </h2>
            <div className="grid grid-cols-2 gap-4 w-full">
              {achievements.map((achieve, i) => (
                <div
                  key={i}
                  className="bg-[#dec196] text-black rounded-md py-6 px-4 text-center font-medium shadow-sm"
                >
                  <div className="text-2xl font-bold">{achieve.count}</div>
                  <div className="text-sm mt-1">{achieve.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
